const OTHER_ID = "Other";
const getIsValueFromOptions = (options, value) => options?.find((option) => option.label === value);
const getIsOtherOptionSelected = (options, value) => Boolean(value) && !getIsValueFromOptions(options, value);
const getOtherLabel = (addOtherLabel, t) => {
  const otherLabelDefault = t?.("add-other.default-other-option-label");
  return addOtherLabel || otherLabelDefault || OTHER_ID;
};
const getOtherValue = (value, addOtherLabel) => {
  const addedSymbolsLength = 2;
  const otherLabelLength = addOtherLabel ? addOtherLabel.length + addedSymbolsLength : 0;
  return value.slice(otherLabelLength);
};
export {
  OTHER_ID,
  getIsOtherOptionSelected,
  getOtherLabel,
  getOtherValue
};
//# sourceMappingURL=radio-group-field-utils.js.map
